import {
    AuthenticatorValidationStatus,
    TokenResponse2FA,
    TokenResponse2FAErrorCode
} from "@/types/autenticationresult";
import TwoFactorAuthenticationAPPService from "@/services/TwoFactorAuth/TwoFactorAuthenticationAPP.service";
import {Store} from "vuex";
import APIDataServices from "@/services/APIDataServices";
import ResponseData from "@/types/ResponseData";
import {Router} from "vue-router";
import {User, UserEmailPasswordDeviceId, UserId} from "@/types/User";
import {DEMOUSEREMAIL} from "@/types/constants";

class APPAuthenticationService {

    process2FAValidationErrorMsg(respuesta: TokenResponse2FA, store: Store<any>) {
        // console.log('process2FAValidationErrorMsg. respuesta: ' + JSON.stringify(respuesta));
        if (respuesta.twoFactorRequired) {
            if (respuesta.errorCode === TokenResponse2FAErrorCode.twoFactorAuthenticationValidationRequired
                && respuesta.twoFactorConfiguredMethods.length === 0) {
                // console.log('caso 1. 2FA activado y sin configurar y validar');
                TwoFactorAuthenticationAPPService.startTwoFactorAuthenticationProcess(store);
            } else if (respuesta.errorCode === TokenResponse2FAErrorCode.twoFactorAuthenticationValidationRequired
                && respuesta.twoFactorConfiguredMethods.includes(TokenResponse2FAErrorCode.Authenticator)) {
                // console.log('caso 2. 2FA activado, configurado y validado');
                if (respuesta.blockEndsAt) {
                    // console.log('usuario bloqueado. respuesta.twoFactorValidationStatus: ' + JSON.stringify(respuesta.blockEndsAt));
                    TwoFactorAuthenticationAPPService.setTwoFactorUserBlockedDate(respuesta.blockEndsAt, store);
                }
                TwoFactorAuthenticationAPPService.setTwoFactorAuthenticationProcess(AuthenticatorValidationStatus.EnabledToValidate, store);

            }
            // console.log('antes de asignar respuesta.twoFactorToken: ' + respuesta.twoFactorToken);
            // BrowsersettingsService.setSessionStoragePropertyValue(sessionStorageTwoFactorTokenVariable, respuesta.twoFactorToken);
            store.commit("setTwoFactorAuthToken", respuesta.twoFactorToken);
        }
    }

    validateAndSetUser(user: User, store: Store<any>) {
        const regex = new RegExp(DEMOUSEREMAIL);
        user.isUserValid = !regex.test(user.email);
        store.commit("setUser", user);
    }
    // processAfterTokenISM(userdata: UserEmailPasswordDeviceId, router: Router, store: Store<any>): boolean {
    //     let result = true;
    //     APIDataServices.getValidateUserISM(userdata)
    //         .then((response: ResponseData) => {
    //             const user = response.data as User;
    //             this.validateAndSetUser(user, store);
    //             const useriddto: UserId = {
    //                 id: user.id
    //             }
    //             APIDataServices.getUserTokenISP(useriddto)
    //                 .then((response: ResponseData) => {
    //                     const token = response.data.token;
    //                     if (token) {
    //                         store.commit("setUserToken", token);
    //                         router.push({path: `/general/plants`});
    //                         this.getGeneralVariables(store);
    //                     } else {
    //                         result = false;
    //                     }
    //                 })
    //                 .catch((error: any) => {
    //                     console.log('error token ISP: ' + JSON.stringify(error.response));
    //                     result = false;
    //                 });
    //         }).catch((error: any) => {
    //         console.log('error validate ISM: ' + JSON.stringify(error.response));
    //         result = false;
    //     });
    //     return result;
    // }

    getGeneralVariables(store: Store<any>) {
        APIDataServices.getGeneralVariables()
            .then((response: ResponseData) => {
                const variables = response.data;
                // console.log('variables: ' + JSON.stringify(variables));
                store.commit("setVariables", variables);
            })
            .catch((e: Error) => {
                // console.log(e);
            });
    }


}

export default new APPAuthenticationService();
